import { useCallback } from "react";
import { Node, Edge } from "@xyflow/react";
import { useSelector } from "react-redux";
import { SequenceNodeData } from "./SequenceNode";
import { ISequence } from "../../models/interactions/Sequence";
import { selectSelectedElement } from "../../app/slices/TrainingSlice";
import { useUpdateActiveSequence } from "./useUpdateActiveSequence.hook";

export function useConnectNodesLeftToRight() {
  const interaction = useSelector(selectSelectedElement) as ISequence;
  const { updateSequence } = useUpdateActiveSequence();

  const connectSelectedNodes = useCallback(
    (selectedNodes: Node<SequenceNodeData>[]) => {
      if (selectedNodes.length < 2) return;

      // Sort nodes by x position (left to right)
      const sortedNodes = [...selectedNodes].sort(
        (a, b) => a.position.x - b.position.x
      );

      // Create edges between consecutive nodes
      const newEdges: Edge[] = [];
      for (let i = 0; i < sortedNodes.length - 1; i++) {
        const sourceNode = sortedNodes[i];
        const targetNode = sortedNodes[i + 1];

        // Check if edge already exists
        const edgeExists = interaction.edges.some(
          (e) => e.source === sourceNode.id && e.target === targetNode.id
        );

        if (!edgeExists) {
          newEdges.push({
            id: `${sourceNode.id}-${targetNode.id}`,
            source: sourceNode.id,
            target: targetNode.id,
            type: "custom",
          });
        }
      }

      if (newEdges.length > 0) {
        updateSequence({
          ...interaction,
          edges: [...interaction.edges, ...newEdges],
        } as ISequence);
      }
    },
    [interaction, updateSequence]
  );

  return { connectSelectedNodes };
}
